export const MORE_30_DAYS = 'MORE_30_DAYS'
export const LESS_30_DAYS = 'LESS_30_DAYS'
export const EXPIRED = 'EXPIRED'
export const NO_EXPIRY = 'NO_EXPIRY'
